import ActionType from "../ActionType";

export const setSiteDetailId = (data: { value: number; label: string }) => ({
  type: ActionType.SET_SITE_ID,
  data: data,
});

export const setProjectSetting = (data: any) => ({
  type: ActionType.SET_PROJECT_SETTINGS,
  data: data,
});
